(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hermex-hero-products"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('hermex-promo-hero')) {

    customElements.define('hermex-promo-hero', class extends HTMLElement {

      connectedCallback() {

        this.abort?.abort();

        cancelAnimationFrame(this.frame);

        this.abort = new AbortController();

        const options = { signal: this.abort.signal };

        this.slides = [...this.querySelectorAll('[data-slide]')];

        if (this.slides.length < 2) return;

        this.index = 0;

        this.elapsed = 0;

        this.lastTime = null;

        this.hovered = false;

        this.focused = false;

        this.progress = this.querySelector('[data-progress]');

        this.motion = matchMedia('(prefers-reduced-motion: reduce)');

        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;

        this.duration = Number(this.dataset.duration) || 4000;

        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);

        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);

        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);

        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);

        document.addEventListener('visibilitychange', () => this.schedule(), options);

        this.motion.addEventListener('change', () => {

          if (this.motion.matches) this.paused = true;

          this.schedule();

        }, options);

        const panel = this.querySelector('.hx-promo__panel');

        panel.addEventListener('keydown', (event) => {

          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          event.preventDefault();

          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));

        }, options);

        panel.addEventListener('touchstart', (event) => { this.touchX = event.touches[0].clientX; }, { ...options, passive: true });

        panel.addEventListener('touchend', (event) => {

          const delta = event.changedTouches[0].clientX - this.touchX;

          if (Math.abs(delta) > 40) this.show(this.index + (delta < 0 ? 1 : -1));

        }, { ...options, passive: true });

        this.loadRemainingPages(this.abort.signal);

        this.show(0);

      }

      async loadRemainingPages(signal) {

        let next = this.querySelector('[data-next-page]')?.getAttribute('href');

        const visited = new Set();

        try {

          while (next && !signal.aborted) {

            const url = new URL(next, window.location.origin);

            url.searchParams.set('section_id', this.dataset.sectionId);

            if (visited.has(url.href)) break;

            visited.add(url.href);

            const response = await fetch(url, { signal });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');

            if (signal.aborted) return;

            const source = html.querySelector('hermex-promo-hero');

            if (!source) throw new Error('Hero section missing from response');

            const added = [...source.querySelectorAll('[data-slide]')];

            added.forEach((slide) => {

              slide.hidden = true;

              slide.querySelectorAll('img').forEach((image) => { image.loading = 'lazy'; });

              this.querySelector('.hx-promo__slides').append(slide);

            });

            this.slides.push(...added);

            next = source.querySelector('[data-next-page]')?.getAttribute('href');

          }

        } catch (error) {

          if (error.name !== 'AbortError') console.warn('HERMEX hero: products could not be loaded', error);

        }

      }

      disconnectedCallback() {

        this.abort?.abort();

        cancelAnimationFrame(this.frame);

      }

      show(index) {

        this.index = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });

        this.elapsed = 0;

        this.progress.style.transform = 'scaleX(0)';

        this.schedule();

      }

      schedule() {

        cancelAnimationFrame(this.frame);

        this.lastTime = null;

        if (this.paused || this.hovered || this.focused || document.hidden || !this.isConnected) return;

        this.frame = requestAnimationFrame((time) => this.tick(time));

      }

      tick(time) {

        if (this.lastTime !== null) this.elapsed += time - this.lastTime;

        this.lastTime = time;

        this.progress.style.transform = `scaleX(${Math.min(this.elapsed / this.duration, 1)})`;

        if (this.elapsed >= this.duration) this.show(this.index + 1);

        else this.frame = requestAnimationFrame((nextTime) => this.tick(nextTime));

      }

    });

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mex-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hermex-mex-header')) {
    const mexDust = {
      owners: new Set(),
      particles: new Map(),
      colors: ['#0E3E37', '#17675B', '#518D84', '#8BB3AD', '#C5D9D6'],
      layer: null,
      controller: null,
      lastTime: -Infinity,

      add(owner) {
        if (owner.dataset.sparkles !== 'true') return;

        this.owners.add(owner);

        if (this.controller) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.pointer = matchMedia(
          '(hover: hover) and (pointer: fine)'
        );

        this.reduced = matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        document.addEventListener(
          'pointermove',
          (event) => this.emit(event),
          { passive: true, signal }
        );

        document.addEventListener(
          'pointerleave',
          () => this.clear(),
          { signal }
        );

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) this.clear();
          },
          { signal }
        );

        window.addEventListener(
          'blur',
          () => this.clear(),
          { signal }
        );

        this.pointer.addEventListener(
          'change',
          () => this.clear(),
          { signal }
        );

        this.reduced.addEventListener(
          'change',
          () => this.clear(),
          { signal }
        );
      },

      emit(event) {
        if (
          event.pointerType !== 'mouse' ||
          !this.pointer.matches ||
          this.reduced.matches ||
          document.hidden ||
          !this.owners.size
        ) {
          return;
        }

        const now = performance.now();

        if (
          now - this.lastTime < 28 ||
          this.particles.size >= 72
        ) {
          return;
        }

        this.lastTime = now;

        if (!this.layer) {
          this.layer = document.createElement('div');
          this.layer.className = 'hermex-mex-sparkle-layer';
          this.layer.setAttribute('aria-hidden', 'true');
          document.body.appendChild(this.layer);
        }

        for (
          let i = 0;
          i < 2 && this.particles.size < 72;
          i += 1
        ) {
          const star = document.createElement('span');

          star.className = 'hermex-mex-sparkle';
          star.style.left = `${event.clientX + Math.random() * 18 - 9}px`;
          star.style.top = `${event.clientY + 7 + Math.random() * 7}px`;

          star.style.color = this.colors[
            Math.floor(Math.random() * this.colors.length)
          ];

          star.style.setProperty(
            '--mex-star-size',
            `${7 + Math.random() * 5}px`
          );

          star.style.setProperty(
            '--mex-star-x',
            `${Math.random() * 44 - 22}px`
          );

          star.style.setProperty(
            '--mex-star-y',
            `${30 + Math.random() * 32}px`
          );

          star.style.setProperty(
            '--mex-star-turn',
            `${Math.random() * 180 - 90}deg`
          );

          this.layer.appendChild(star);

          const timer = setTimeout(() => {
            star.remove();
            this.particles.delete(star);
          }, 960);

          this.particles.set(star, timer);
        }
      },

      clear() {
        for (const [star, timer] of this.particles) {
          clearTimeout(timer);
          star.remove();
        }

        this.particles.clear();
        this.lastTime = -Infinity;
      },

      remove(owner) {
        this.owners.delete(owner);

        if (this.owners.size) return;

        if (this.controller) {
          this.controller.abort();
        }

        this.controller = null;
        this.clear();

        if (this.layer) {
          this.layer.remove();
        }

        this.layer = null;
      }
    };

    customElements.define(
      'hermex-mex-header',
      class extends HTMLElement {
        connectedCallback() {
          if (this.mexController) return;

          this.mexStage = this.querySelector('[data-mex-stage]');

          if (!this.mexStage) return;

          this.mexController = new AbortController();
          this.mexIntroTimers = new Set();

          const signal = this.mexController.signal;

          this.mexPointer = matchMedia(
            '(hover: hover) and (pointer: fine)'
          );

          this.mexReduced = matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.mexMaxX = Math.min(
            8,
            Math.max(0, Number(this.dataset.travelX) || 0)
          );

          this.mexMaxY = Math.min(
            5,
            Math.max(0, Number(this.dataset.travelY) || 0)
          );

          this.mexTarget = { x: 0, y: 0 };
          this.mexCurrent = { x: 0, y: 0 };
          this.mexFrame = 0;
          this.mexTime = 0;
          this.mexTick = this.mexAnimate.bind(this);

          this.mexPaint();

          this.addEventListener(
            'pointermove',
            (event) => {
              if (
                event.pointerType === 'touch' ||
                this.dataset.motion !== 'true' ||
                !this.mexPointer.matches ||
                this.mexReduced.matches
              ) {
                return;
              }

              const rect = this.mexStage.getBoundingClientRect();

              if (!rect.width || !rect.height) return;

              const dx = (
                event.clientX -
                rect.left -
                rect.width * .5
              ) / (rect.width * .25);

              const dy = (
                event.clientY -
                rect.top -
                rect.height * (450 / 856)
              ) / (rect.height * .35);

              const limit = Math.max(
                1,
                Math.hypot(dx, dy)
              );

              this.mexMove(
                this.mexMaxX * dx / limit,
                this.mexMaxY * dy / limit
              );
            },
            { passive: true, signal }
          );

          this.addEventListener(
            'pointerleave',
            () => this.mexMove(0, 0),
            { signal }
          );

          this.addEventListener(
            'pointercancel',
            () => this.mexMove(0, 0),
            { signal }
          );

          window.addEventListener(
            'blur',
            () => this.mexReset(),
            { signal }
          );

          window.addEventListener(
            'resize',
            () => this.mexReset(),
            { signal }
          );

          document.addEventListener(
            'visibilitychange',
            () => {
              if (document.hidden) this.mexReset();
            },
            { signal }
          );

          this.mexPointer.addEventListener(
            'change',
            () => this.mexReset(),
            { signal }
          );

          this.mexReduced.addEventListener(
            'change',
            () => {
              this.mexReset();

              if (this.mexReduced.matches) {
                this.mexFinishIntro();
              }
            },
            { signal }
          );

          this.addEventListener(
            'focusin',
            () => this.mexFinishIntro(),
            { signal }
          );

          mexDust.add(this);
          this.mexStartIntro();
        }

        mexStartIntro() {
          if (
            this.dataset.intro !== 'true' ||
            this.mexReduced.matches ||
            window.Shopify?.designMode ||
            this.mexIntroSeen
          ) {
            this.mexFinishIntro();
            return;
          }

          this.mexIntroSeen = true;

          const controller = this.mexController;
          const session = {};

          this.mexIntroSession = session;

          const later = (callback, delay) => {
            const timer = setTimeout(() => {
              this.mexIntroTimers.delete(timer);

              if (
                this.isConnected &&
                this.mexController === controller &&
                this.mexIntroSession === session
              ) {
                callback();
              }
            }, delay);

            this.mexIntroTimers.add(timer);

            return timer;
          };

          let started = false;
          let fallback;

          const start = () => {
            if (
              started ||
              this.mexController !== controller ||
              !this.isConnected ||
              this.mexIntroSession !== session
            ) {
              return;
            }

            started = true;

            clearTimeout(fallback);
            this.mexIntroTimers.delete(fallback);

            later(() => {
              if (this.mexReduced.matches) {
                this.mexFinishIntro();
                return;
              }

              this.classList.remove('mex-intro-pending');
              this.classList.add('mex-intro-running');

              later(
                () => this.mexFinishIntro(),
                760
              );
            }, 180);
          };

          const images = [
            this.querySelector('.mex-header__eyes img'),
            this.querySelector('.mex-header__body')
          ].filter(
            (image) => image && !image.complete
          );

          let remaining = images.length;

          fallback = later(start, 450);

          for (const image of images) {
            let settled = false;

            const ready = () => {
              if (
                settled ||
                this.mexController !== controller ||
                this.mexIntroSession !== session
              ) {
                return;
              }

              settled = true;
              remaining -= 1;

              if (!remaining) start();
            };

            image.addEventListener(
              'load',
              ready,
              {
                once: true,
                signal: controller.signal
              }
            );

            image.addEventListener(
              'error',
              ready,
              {
                once: true,
                signal: controller.signal
              }
            );
          }

          this.classList.add('mex-intro-pending');

          if (!remaining) start();
        }

        mexFinishIntro() {
          this.mexIntroSession = null;

          if (this.mexIntroTimers) {
            for (const timer of this.mexIntroTimers) {
              clearTimeout(timer);
            }

            this.mexIntroTimers.clear();
          }

          this.classList.remove(
            'mex-intro-pending',
            'mex-intro-running'
          );
        }

        mexMove(x, y) {
          this.mexTarget = { x, y };

          if (!this.mexFrame) {
            this.mexFrame = requestAnimationFrame(
              this.mexTick
            );
          }
        }

        mexAnimate(time) {
          this.mexFrame = 0;

          const dt = this.mexTime
            ? Math.min(40, Math.max(1, time - this.mexTime))
            : 16;

          this.mexTime = time;

          const easing = 1 - Math.exp(-dt / 90);

          this.mexCurrent.x += (
            this.mexTarget.x - this.mexCurrent.x
          ) * easing;

          this.mexCurrent.y += (
            this.mexTarget.y - this.mexCurrent.y
          ) * easing;

          const moving = (
            Math.abs(this.mexTarget.x - this.mexCurrent.x) +
            Math.abs(this.mexTarget.y - this.mexCurrent.y)
          ) > .015;

          if (!moving) {
            this.mexCurrent = {
              ...this.mexTarget
            };
          }

          this.mexPaint();

          if (moving) {
            this.mexFrame = requestAnimationFrame(
              this.mexTick
            );
          } else {
            this.mexTime = 0;
          }
        }

        mexPaint() {
          this.style.setProperty(
            '--mex-look-x',
            `${this.mexCurrent.x / 1728 * 100}%`
          );

          this.style.setProperty(
            '--mex-look-y',
            `${this.mexCurrent.y / 856 * 100}%`
          );
        }

        mexReset() {
          cancelAnimationFrame(this.mexFrame);

          this.mexFrame = 0;
          this.mexTime = 0;
          this.mexTarget = { x: 0, y: 0 };
          this.mexCurrent = { x: 0, y: 0 };

          this.mexPaint();
        }

        disconnectedCallback() {
          if (!this.mexController) return;

          this.mexFinishIntro();
          mexDust.remove(this);
          this.mexController.abort();

          cancelAnimationFrame(this.mexFrame);

          this.mexController = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mex-kennenlernen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hermex-mex-hobbies-v3')) {
    class HermexMexHobbies extends HTMLElement {
      connectedCallback() {
        if (this._startFrame || this._controller) return;

        this._startFrame = requestAnimationFrame(() => {
          this._startFrame = null;

          if (this.isConnected) {
            this.init();
          }
        });
      }

      init() {
        this.track = this.querySelector('.mxk__track');

        this.cards = Array.from(
          this.querySelectorAll('[data-mxk-card]')
        );

        this.nav = this.querySelector('[data-mxk-nav]');
        this.prev = this.querySelector('[data-mxk-prev]');
        this.next = this.querySelector('[data-mxk-next]');

        this.dots = Array.from(
          this.querySelectorAll('[data-mxk-dot]')
        );

        this.headingEl = this.querySelector('[data-mxk-title]');
        this.titleSource = this.querySelector('[data-mxk-title-source]');

        if (
          !this.track ||
          !this.nav ||
          !this.prev ||
          !this.next
        ) {
          return;
        }

        this._controller = new AbortController();
        const signal = this._controller.signal;

        this.querySelectorAll('[data-mxk-like]').forEach(button => {
          button.hidden = false;
        });

        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;

          const like = event.target.closest('[data-mxk-like]');

          if (like) {
            const selected =
              like.getAttribute('aria-pressed') !== 'true';

            like.setAttribute('aria-pressed', String(selected));

            like.closest('[data-mxk-card]').classList.toggle(
              'is-selected',
              selected
            );

            return;
          }

          const dot = event.target.closest('[data-mxk-dot]');

          if (dot) {
            this.goTo(Number(dot.dataset.mxkDot));
          } else if (event.target.closest('[data-mxk-prev]')) {
            this.goTo(this.currentIndex() - 1);
          } else if (event.target.closest('[data-mxk-next]')) {
            this.goTo(this.currentIndex() + 1);
          }
        }, { signal });

        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || this.nav.hidden) {
            return;
          }

          const targets = {
            ArrowLeft: this.currentIndex() - 1,
            ArrowRight: this.currentIndex() + 1,
            Home: 0,
            End: this.cards.length - 1
          };

          if (
            Object.prototype.hasOwnProperty.call(
              targets,
              event.key
            )
          ) {
            event.preventDefault();
            this.goTo(targets[event.key]);
          }
        }, { signal });

        this.track.addEventListener('scroll', () => {
          if (this._scrollFrame) return;

          this._scrollFrame = requestAnimationFrame(() => {
            this._scrollFrame = null;
            this.updateNavigation();
          });
        }, {
          passive: true,
          signal
        });

        this.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element)) return;

          const card = event.target.closest('[data-mxk-card]');
          const index = this.cards.indexOf(card);

          if (index >= 0) {
            this.goTo(index, true);
          }
        }, { signal });

        const refresh = () => {
          this.updateNavigation();
          this.queueTitle();
        };

        window.addEventListener('resize', refresh, { signal });

        if ('ResizeObserver' in window) {
          this._observer = new ResizeObserver(() => {
            this.updateNavigation();

            if (
              this.headingEl &&
              this.headingEl.clientWidth !== this._titleWidth
            ) {
              this.queueTitle();
            }
          });

          this._observer.observe(this.track);

          if (this.headingEl) {
            this._observer.observe(this.headingEl);
          }
        }

        if (document.fonts) {
          document.fonts.ready.then(() => {
            this.queueTitle();
          });

          document.fonts.addEventListener('loadingdone', () => {
            this.queueTitle();
          }, { signal });
        }

        refresh();
      }

      queueTitle() {
        if (
          !this.isConnected ||
          !this._controller ||
          this._titleFrame
        ) {
          return;
        }

        this._titleFrame = requestAnimationFrame(() => {
          this._titleFrame = null;

          if (this.isConnected) {
            this.drawTitle();
          }
        });
      }

      drawTitle() {
        if (!this.headingEl || !this.titleSource) return;

        const width = this.headingEl.clientWidth;

        const content = this.titleSource.textContent
          .trim()
          .replace(/\s+/g, ' ');

        if (!width || !content) return;

        this._titleWidth = width;

        const ns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(ns, 'svg');

        svg.classList.add('mxk__title-art');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');

        svg.style.cssText =
          'position:absolute;visibility:hidden;width:100%;height:1px;';

        this.headingEl.appendChild(svg);

        try {
          let size =
            parseFloat(getComputedStyle(this.headingEl).fontSize) || 72;

          const stroke = parseFloat(
            getComputedStyle(this).getPropertyValue('--mxk-title-stroke')
          ) || 8;

          const pad = stroke / 2 + 3;
          const available = Math.max(1, width - 2 * pad);

          svg.style.fontSize = size + 'px';

          const probe = document.createElementNS(ns, 'text');
          svg.appendChild(probe);

          const measure = text => {
            probe.textContent = text;

            return Math.max(
              probe.getComputedTextLength(),
              probe.getBBox().width
            );
          };

          /*
            "am liebsten" bleibt als Wortgruppe zusammen
            und wird gelb eingefärbt.
          */
          const words = content.match(/am\s+liebsten|\S+/gi) || [];
          const widest = Math.max(1, ...words.map(measure));

          if (widest > available) {
            size *= available / widest;
            svg.style.fontSize = size + 'px';
          }

          const lines = [];
          let line = [];

          words.forEach(word => {
            const candidate = [...line, word];

            if (
              line.length &&
              measure(candidate.join(' ')) > available
            ) {
              lines.push(line);
              line = [word];
            } else {
              line = candidate;
            }
          });

          if (line.length) {
            lines.push(line);
          }

          probe.remove();

          const group = document.createElementNS(ns, 'g');
          svg.appendChild(group);

          lines.forEach((parts, index) => {
            const text = document.createElementNS(ns, 'text');

            text.setAttribute('x', '0');
            text.setAttribute('y', String(index * size * 1.14));

            parts.forEach((word, i) => {
              const span = document.createElementNS(ns, 'tspan');

              span.textContent = (i ? ' ' : '') + word;

              if (/^am\s+liebsten$/i.test(word)) {
                span.setAttribute('data-mxk-gold', '');
              }

              text.appendChild(span);
            });

            group.appendChild(text);

            const bounds = text.getBBox();

            text.setAttribute(
              'x',
              String((width - bounds.width) / 2 - bounds.x)
            );
          });

          const bounds = group.getBBox();

          if (!bounds.width || !bounds.height) {
            throw new Error('Title not measurable');
          }

          const height = Math.ceil(bounds.height + 2 * pad);

          svg.setAttribute(
            'viewBox',
            `0 ${bounds.y - pad} ${width} ${height}`
          );

          svg.setAttribute('width', String(width));
          svg.setAttribute('height', String(height));

          svg.style.cssText =
            `display:block;width:100%;height:${height}px;font-size:${size}px;`;

          this.headingEl.querySelectorAll('.mxk__title-art').forEach(old => {
            if (old !== svg) {
              old.remove();
            }
          });

          this.headingEl.classList.add('has-svg');
        } catch (error) {
          svg.remove();

          /*
            Falls SVG nicht gemessen werden kann,
            bleibt der normale HTML-Titel vorhanden.
          */
        }
      }

      positionFor(index) {
        const card = this.cards[index];

        if (!card) return 0;

        const padding =
          parseFloat(getComputedStyle(this.track).paddingLeft) || 0;

        const x =
          card.getBoundingClientRect().left
          - this.track.getBoundingClientRect().left
          + this.track.scrollLeft
          - padding;

        return Math.max(
          0,
          Math.min(
            x,
            this.track.scrollWidth - this.track.clientWidth
          )
        );
      }

      currentIndex() {
        let best = 0;
        let distance = Infinity;

        this.cards.forEach((card, index) => {
          const delta = Math.abs(
            this.positionFor(index) - this.track.scrollLeft
          );

          if (delta < distance) {
            distance = delta;
            best = index;
          }
        });

        return best;
      }

      goTo(index, instant = false) {
        if (
          !this.cards.length ||
          getComputedStyle(this.track).display !== 'flex' ||
          this.track.scrollWidth <= this.track.clientWidth + 2
        ) {
          return;
        }

        const target = Math.max(
          0,
          Math.min(index, this.cards.length - 1)
        );

        const reduce = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.track.scrollTo({
          left: this.positionFor(target),
          behavior: instant || reduce ? 'auto' : 'smooth'
        });
      }

      updateNavigation() {
        const overflow =
          getComputedStyle(this.track).display === 'flex' &&
          this.track.scrollWidth > this.track.clientWidth + 2;

        this.nav.hidden = !overflow || this.cards.length < 2;
        this.track.tabIndex = overflow ? 0 : -1;

        const current = this.currentIndex();

        this.prev.disabled = this.track.scrollLeft <= 2;

        this.next.disabled =
          this.track.scrollLeft >=
          this.track.scrollWidth - this.track.clientWidth - 2;

        this.dots.forEach((dot, index) => {
          if (index === current) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      disconnectedCallback() {
        if (this._controller) {
          this._controller.abort();
        }

        if (this._observer) {
          this._observer.disconnect();
        }

        if (this._startFrame) {
          cancelAnimationFrame(this._startFrame);
        }

        if (this._scrollFrame) {
          cancelAnimationFrame(this._scrollFrame);
        }

        if (this._titleFrame) {
          cancelAnimationFrame(this._titleFrame);
        }

        this._controller = null;
        this._observer = null;
        this._titleFrame = null;
        this._startFrame = null;
        this._scrollFrame = null;
      }
    }

    customElements.define(
      'hermex-mex-hobbies-v3',
      HermexMexHobbies
    );
  }

  } catch(e) { console.error(e); }
})();
})();
